



















































































class SheduleType {
    id?: number;
    name?: string;
}

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TextInput from "@/components/TextInput.vue";
import { Schedule, ScheduleDay, ScheduleWeek, ScheduleMonth } from '@/models/schedule.model';

@Component({
    components:{
        TextInput
    }

})
export default class SchedulePanel extends Vue{
    @Prop() schedule!:any;

    weekDaysSwe:string[] = ["Mån", "Tis", "Ons","Tor","Fre","Lör","Sön"];
    monthsSwe:string[] = ["Jan", "Feb", "Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"];
    numDays:number = 31;

    sheduleTypes:SheduleType[] = [ { id:1, name:"En gång"}, { id:2, name:"Vecka"}, { id:3, name:"Månad"}  ];

    // types:number = 1;
    // startDate:Date = new Date;
    selectedDayInWeek:any[] = [];
    selectedDayInMonth:any[] = [];
    selectedMonthInYear:any[] = [];
    repeatWeeks:number = 1;

    scheduleObject: Schedule = {startDate:new Date, scheduleType:1, repeatWeeks:1, scheduleWeeks : [], scheduleDays : [], scheduleMonths : [] };

    mounted(){
        // alert("hej schema");
        // this.scheduleObject.scheduleType = 1;
        // this.scheduleObject.startDate = new Date;
        if(this.schedule !== undefined){
            this.scheduleObject = this.schedule;
            this.selectedDayInWeek = this.scheduleObject.scheduleWeeks !== undefined ? this.scheduleObject.scheduleWeeks!.map(sw => sw.dayOfWeek!-1) : [];
            this.selectedDayInMonth = this.scheduleObject.scheduleDays !== undefined ? this.scheduleObject.scheduleDays!.map(sd => sd.dayOfMonth!-1) : [];
            this.selectedMonthInYear = this.scheduleObject.scheduleMonths !== undefined ? this.scheduleObject.scheduleMonths!.map(sm => sm.monthOfYear!-1) : [];
        }
    }

    @Watch('schedule')
    scheduleChanged(){
        if(this.schedule !== undefined){
            this.scheduleObject = this.schedule;
            this.selectedDayInWeek = this.scheduleObject.scheduleWeeks !== undefined ? this.scheduleObject.scheduleWeeks!.map(sw => sw.dayOfWeek!-1) : [];
            this.selectedDayInMonth = this.scheduleObject.scheduleDays !== undefined ? this.scheduleObject.scheduleDays!.map(sd => sd.dayOfMonth!-1) : [];
            this.selectedMonthInYear = this.scheduleObject.scheduleMonths !== undefined ? this.scheduleObject.scheduleMonths!.map(sm => sm.monthOfYear!-1) : [];
        }
    }

    @Watch('scheduleObject.repeatWeeks')
    validateWeek(){
        this.scheduleObject.repeatWeeks = this.scheduleObject.repeatWeeks! < 1 ? 1 : this.scheduleObject.repeatWeeks;
        this.scheduleObject.repeatWeeks = this.scheduleObject.repeatWeeks! > 52 ? 52 : this.scheduleObject.repeatWeeks;
        this.scheduleEmit();
    }

    @Watch('scheduleObject.scheduleType',{ immediate: false, deep: true })
    async typeChanged(newValue:any, oldValue:any){
        if(oldValue == 2){
            this.scheduleObject.repeatWeeks = 1;
        }

        switch(this.scheduleObject.scheduleType){
            case 1:
                this.scheduleObject.scheduleDays = [];
                this.scheduleObject.scheduleWeeks = [];
                this.scheduleObject.scheduleMonths = [];

                this.selectedDayInWeek = [];
                this.selectedDayInMonth = [];
                this.selectedMonthInYear = [];
                break;
            case 2:
                this.scheduleObject.scheduleDays = [];
                this.scheduleObject.scheduleMonths = [];
                this.selectedDayInMonth = [];
                this.selectedMonthInYear = [];
            break;
            case 3:
                this.scheduleObject.scheduleWeeks = [];
                this.selectedDayInWeek = [];
            break;
        }

        this.scheduleEmit();
    }

    @Watch('scheduleObject.startDate')
    async startDateChanged(){
        this.scheduleEmit();
    }

    @Watch('selectedDayInWeek')
    async dayChanged(){
        this.scheduleObject.scheduleWeeks = [];

        this.selectedDayInWeek.forEach(day => {
            this.scheduleObject.scheduleWeeks!.push({ dayOfWeek:day+1, scheduleId:this.scheduleObject.id });
        });

        this.scheduleEmit();
    }

    @Watch('selectedDayInMonth')
    async daysChanged(){
        this.scheduleObject.scheduleDays = [];

        this.selectedDayInMonth.forEach(day => {
            this.scheduleObject.scheduleDays!.push({ dayOfMonth:day+1, scheduleId:this.scheduleObject.id });
        });

        this.scheduleEmit();
    }

    @Watch('selectedMonthInYear')
    async monthChanged(){
        this.scheduleObject.scheduleMonths = [];

        this.selectedMonthInYear.forEach(month => {
            this.scheduleObject.scheduleMonths!.push({ monthOfYear:month+1, scheduleId:this.scheduleObject.id });
        });

        this.scheduleEmit();
    }

    scheduleEmit(){
        this.$emit("scheduleEmit", this.scheduleObject);
    }

    
}
